module.exports = __webpack_public_path__ + "img/oxycontin.5f99a616.png";